// Generated by `bazel run i18n`. Do not edit by hand.
import inboundDashboard_21ed8bad from "./en/analytics--app--src--analytics--inbound-dashboard.json";
import states_a86d9120 from "./en/analytics--app--src--analytics--reports--custom--components--states.json";
import components_562f17ab from "./en/analytics--app--src--analytics--reports--custom--components.json";
import filters_b30cdd9f from "./en/analytics--app--src--analytics--reports--custom--filters.json";
import hooks_23683116 from "./en/analytics--app--src--analytics--reports--custom--hooks.json";
import checkoutPlusRewards_e794283c from "./en/analytics--app--src--analytics--returns-claims--checkout-plus-rewards.json";
import carriers_055d45e4 from "./en/analytics--app--src--analytics--returns-claims--claim--components--carriers.json";
import components_89217572 from "./en/analytics--app--src--analytics--returns-claims--claim--components.json";
import hooks_423890f7 from "./en/analytics--app--src--analytics--returns-claims--claim--hooks.json";
import insights_1d758917 from "./en/analytics--app--src--analytics--returns-claims--insights.json";
import operations_a69114ba from "./en/analytics--app--src--analytics--returns-claims--operations.json";
import components_3852438d from "./en/analytics--app--src--analytics--returns-claims--overview--components.json";
import overview_f9436386 from "./en/analytics--app--src--analytics--returns-claims--overview.json";
import hooks_0198825c from "./en/analytics--app--src--analytics--returns-claims--portal--components--hooks.json";
import components_776871f8 from "./en/analytics--app--src--analytics--returns-claims--portal--components.json";
import portal_21cbb2cf from "./en/analytics--app--src--analytics--returns-claims--portal.json";
import filters_4b179511 from "./en/analytics--app--src--analytics--returns-claims--product--components--filters.json";
import configs_7d187c89 from "./en/analytics--app--src--analytics--returns-claims--product--components--table--configs.json";
import table_e613b3e1 from "./en/analytics--app--src--analytics--returns-claims--product--components--table.json";
import components_ccbd5b37 from "./en/analytics--app--src--analytics--returns-claims--product--components.json";
import product_973280aa from "./en/analytics--app--src--analytics--returns-claims--product.json";
import components_5c9b22c0 from "./en/analytics--app--src--analytics--returns-claims--returns--components.json";
import hooks_96d4cc66 from "./en/analytics--app--src--analytics--returns-claims--returns--hooks.json";
import returns_e5c8651f from "./en/analytics--app--src--analytics--returns-claims--returns.json";
import shared_369ac6b7 from "./en/analytics--app--src--analytics--returns-claims--shared.json";
import returnsClaims_3629dcf9 from "./en/analytics--app--src--analytics--returns-claims.json";
import analytics_75bbeb2b from "./en/analytics--app--src--analytics.json";
import attribution_c773b9ec from "./en/app-common--src--attribution.json";
import taxIdentifiers_03bd63a7 from "./en/app-common--src--components--tax-identifiers.json";
import translations_e8ab17df from "./en/app-common--src--components--translations.json";
import dns_7ffb1e4d from "./en/app-common--src--dns.json";
import setting_c1bbd3dc from "./en/app-common--src--setting.json";
import support_6d8651c6 from "./en/app-common--src--support.json";
import tag_d63212fd from "./en/app-common--src--tag.json";
import walkthrough_0fcac945 from "./en/app-common--src--walkthrough.json";
import actionPanel_35b620eb from "./en/customer--app--src--action-panel.json";
import components_c3b95532 from "./en/customer--app--src--all-customers--components.json";
import cards_5b44e739 from "./en/customer--app--src--customer-detail--customer-activity--cards.json";
import feedEntry_4c8e9a44 from "./en/customer--app--src--customer-detail--customer-activity--feed-entry.json";
import customerActivity_15f7b637 from "./en/customer--app--src--customer-detail--customer-activity.json";
import customerDetail_2cbed25c from "./en/customer--app--src--customer-detail.json";
import customEventComponents_855945b8 from "./en/customer--app--src--customer-journey--components--custom-event-components.json";
import customerJourneyTable_9eb3ba88 from "./en/customer--app--src--customer-journey--components--customer-journey-table.json";
import constants_02c6dc11 from "./en/customer--app--src--customer-journey--constants.json";
import customerJourney_bf7edacc from "./en/customer--app--src--customer-journey.json";
import components_c4508ec9 from "./en/customer--app--src--customer-record--components.json";
import customerRecord_1a5fe625 from "./en/customer--app--src--customer-record.json";
import loyalty_5d5d02c8 from "./en/customer--app--src--loyalty.json";
import src_3a197aa1 from "./en/customer--app--src.json";
import logs_67fdff53 from "./en/general--app--src--developer--logs.json";
import giftReceiptRequests_963b6dbc from "./en/general--app--src--gift-receipt-requests.json";
import inmarBlindReturns_e4bb4f0a from "./en/general--app--src--inmar-blind-returns.json";
import brandKit_0b1d74ec from "./en/general--app--src--setting--brand-kit.json";
import communication_04bf5a69 from "./en/general--app--src--setting--communication.json";
import ai_1b80877a from "./en/general--app--src--setting--customer-portal-builder--ai.json";
import centerStage_45d156d9 from "./en/general--app--src--setting--customer-portal-builder--center-stage.json";
import header_2eefb12c from "./en/general--app--src--setting--customer-portal-builder--header.json";
import address_0f0821f3 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--address.json";
import aiExchangeRecommendations_e7d1a7a4 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--ai-exchange-recommendations.json";
import cantFindItem_f960bed2 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--cant-find-item.json";
import compensationMethod_6c0afacd from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--compensation-method.json";
import confirmation_9fa1d81f from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--confirmation.json";
import contactInformation_245a8ebf from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--contact-information.json";
import itemDetails_2dc93089 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--item-details.json";
import login_ac96d533 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--login.json";
import orderDetails_c67a96b6 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--order-details.json";
import purchaseChannel_3c832b29 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--purchase-channel.json";
import registrationAddress_b2a4c7f9 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--registration-address.json";
import registrationCatalog_46551a78 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--registration-catalog.json";
import returnType_28d0b002 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--return-type.json";
import review_913a5711 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--review.json";
import selectItems_5bac69e1 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--select-items.json";
import shipmentMethod_a878eb30 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--shipment-method.json";
import pages_f2cf29fd from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages.json";
import translations_ff46a007 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--translations.json";
import settings_3063afb8 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings.json";
import branding_53967c7d from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles--branding.json";
import globalCards_a039dc7e from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles--global-cards.json";
import selectionCards_98c72ba2 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles--selection-cards.json";
import buttons_101098c3 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--buttons.json";
import general_7b948df2 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--general.json";
import selection_251813f0 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--selection.json";
import typography_1193ed33 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--typography.json";
import stylesV2_8a237655 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2.json";
import styles_7da21905 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles.json";
import leftPanel_250f52a9 from "./en/general--app--src--setting--customer-portal-builder--left-panel.json";
import rightPanel_754a74ee from "./en/general--app--src--setting--customer-portal-builder--right-panel.json";
import customerPortalBuilder_27227ac9 from "./en/general--app--src--setting--customer-portal-builder.json";
import customerPortal_a30dce25 from "./en/general--app--src--setting--customer-portal.json";
import components_d0ef8985 from "./en/general--app--src--setting--developer--components.json";
import modals_4a90e1f7 from "./en/general--app--src--setting--developer--modals.json";
import developer_5c5da90e from "./en/general--app--src--setting--developer.json";
import tabs_218e9e8d from "./en/general--app--src--setting--notification--tabs.json";
import notification_efc204ed from "./en/general--app--src--setting--notification.json";
import roles_76be9fd7 from "./en/general--app--src--setting--roles.json";
import user_32350224 from "./en/general--app--src--setting--user.json";
import withdrawals_46204b05 from "./en/general--app--src--setting--withdrawals.json";
import promptHelper_dd9db353 from "./en/marketing--app--src--common--prompt-helper.json";
import shopperAgent_8e5151c4 from "./en/marketing--app--src--common--shopper-agent.json";
import playbook_c693daf2 from "./en/marketing--app--src--marketing-agent--marketing-agent-shopper-agent--playbook.json";
import marketingAgent_344332c5 from "./en/marketing--app--src--marketing-agent.json";
import settings_7dd2f8d1 from "./en/marketing--app--src--text-concierge--settings.json";
import audienceDashboard_b3f033c0 from "./en/recognize--app--src--audience-dashboard.json";
import vips_8110ac5c from "./en/recognize--app--src--vips.json";
import settings_4001f2b5 from "./en/review--app--src--settings.json";
import notifications_0d402db5 from "./en/src--app--banner--notifications.json";
import desktopHandoff_b1c27e4d from "./en/src--app--desktop-handoff.json";
import settingsRoutes_c2d5b5e5 from "./en/src--app--navigation--routing--settings-routes.json";
import routing_e6167abf from "./en/src--app--navigation--routing.json";
import aeo_053900a3 from "./en/src--app--navigation--side-navigation--aeo.json";
import analytics_12388d41 from "./en/src--app--navigation--side-navigation--analytics.json";
import catalog_90895975 from "./en/src--app--navigation--side-navigation--catalog.json";
import conversion_4ba21609 from "./en/src--app--navigation--side-navigation--conversion.json";
import customers_6a30f0b6 from "./en/src--app--navigation--side-navigation--customers.json";
import developer_b8383ce2 from "./en/src--app--navigation--side-navigation--developer.json";
import globalSearchTools_2865a997 from "./en/src--app--navigation--side-navigation--global-search-tools.json";
import globalSearch_ed826cb9 from "./en/src--app--navigation--side-navigation--global-search.json";
import home_d05467c4 from "./en/src--app--navigation--side-navigation--home.json";
import inventory_432b3f2c from "./en/src--app--navigation--side-navigation--inventory.json";
import marketing_adc89992 from "./en/src--app--navigation--side-navigation--marketing.json";
import orders_c583846d from "./en/src--app--navigation--side-navigation--orders.json";
import payments_2aba0925 from "./en/src--app--navigation--side-navigation--payments.json";
import redoSupplies_d0ce5a55 from "./en/src--app--navigation--side-navigation--redo-supplies.json";
import returns_317b6b37 from "./en/src--app--navigation--side-navigation--returns.json";
import shipping_408b74d9 from "./en/src--app--navigation--side-navigation--shipping.json";
import shopperAgent_e9556136 from "./en/src--app--navigation--side-navigation--shopper-agent.json";
import support_9727fd1a from "./en/src--app--navigation--side-navigation--support.json";
import sideNavigation_1d8784bf from "./en/src--app--navigation--side-navigation.json";
import topNavigation_7821708d from "./en/src--app--navigation--top-navigation.json";
import app_fbb2aba2 from "./en/src--app.json";
import components_80f8d596 from "./en/src--components.json";
import spotCheck_319f9453 from "./en/src--concierge--dashboard--spot-check.json";
import dashboard_b0e03f73 from "./en/src--concierge--dashboard.json";
import detailPage_24a7606a from "./en/src--conversion--ab-tests--detail-page.json";
import inspectors_d33c17d5 from "./en/src--conversion--post-purchase--builder--post-purchase-elements--inspectors.json";
import onboardingCards_8c40f8ad from "./en/src--feature-onboarding--onboarding-cards.json";
import onboardingModals_2b3b826a from "./en/src--feature-onboarding--onboarding-modals.json";
import withdrawalsOnboarding_ff91268b from "./en/src--feature-onboarding--withdrawals-onboarding.json";
import homepage_828baad7 from "./en/src--homepage.json";
import catalog_ed1c5550 from "./en/src--integrations--catalog.json";
import configs_59d1feff from "./en/src--integrations--components--configs.json";
import hooks_afec978a from "./en/src--integrations--components--hooks.json";
import integrationCards_be5acfd5 from "./en/src--integrations--components--integration-cards.json";
import shared_bb073394 from "./en/src--integrations--components--shared.json";
import components_586226e0 from "./en/src--integrations--components.json";
import pages_857590db from "./en/src--integrations--pages.json";
import activationSections_37cde5dc from "./en/src--integrations--panels--activation-sections.json";
import panels_141dca66 from "./en/src--integrations--panels.json";
import automations_7008a3c6 from "./en/src--marketing--automations.json";
import onboarding_f4ee3d91 from "./en/src--onboarding.json";
import actionPanel_d7c36aa3 from "./en/src--order--action-panel.json";
import hooks_9b9b5238 from "./en/src--order--hooks.json";
import statCards_1fad02c2 from "./en/src--order--order-details--stat-cards.json";
import tnplTimeline_66a262a1 from "./en/src--order--order-details--tnpl-timeline.json";
import orderDetails_dc7b8814 from "./en/src--order--order-details.json";
import ordersTable_c57b9e27 from "./en/src--order--orders-table.json";
import orderSyncProgress_58cdab5b from "./en/src--order-sync-progress.json";
import orders_0a6b437a from "./en/src--order-tracking--orders.json";
import order_9b6d226e from "./en/src--order.json";
import settings_6f0866a9 from "./en/src--payments--chargebacks--settings.json";
import chargebacks_bf3b0d55 from "./en/src--payments--chargebacks.json";
import hsa_22f2773c from "./en/src--payments--hsa.json";
import walkthrough_03ff12ba from "./en/src--plg-homepage--walkthrough.json";
import plgHomepage_82c55fb1 from "./en/src--plg-homepage.json";
import plg_07d99c25 from "./en/src--plg.json";
import inspectors_6caeb6d0 from "./en/src--popups--inspectors.json";
import popups_0814e281 from "./en/src--popups.json";
import customerTabs_edb94fdc from "./en/src--registration--customer-tabs.json";
import registration_2a4a33c5 from "./en/src--registration.json";
import actionPanel_610b1f2b from "./en/src--return--action-panel.json";
import bar_a1457686 from "./en/src--return--bulk-actions--bar.json";
import modals_a02582b1 from "./en/src--return--bulk-actions--modals.json";
import model_ef9a416c from "./en/src--return--bulk-actions--model.json";
import toasts_60c2e7eb from "./en/src--return--bulk-actions--toasts.json";
import bulkActions_c652ed86 from "./en/src--return--bulk-actions.json";
import editItemDisposition_a672bbe4 from "./en/src--return--edit-item-disposition.json";
import experience_aee5a645 from "./en/src--return--experience.json";
import fraud_8894238a from "./en/src--return--fraud.json";
import hooks_e71ccff7 from "./en/src--return--hooks.json";
import processingProgress_c0acce91 from "./en/src--return--processing-progress.json";
import recordCreate_0506b0ac from "./en/src--return--record-create.json";
import experience_58941a1d from "./en/src--return--record-home--experience.json";
import jumpTo_7e9b2c2f from "./en/src--return--record-home--sections--jump-to.json";
import needsAction_1e0d46ad from "./en/src--return--record-home--sections--needs-action.json";
import quickViews_69372e0d from "./en/src--return--record-home--sections--quick-views.json";
import search_2ca595cb from "./en/src--return--record-home--sections--search.json";
import sources_b98f900a from "./en/src--return--record-home--sources.json";
import restockBins_6fa17c68 from "./en/src--return--restock-bins.json";
import returnActions_ce2f46a2 from "./en/src--return--return-actions.json";
import returnDetailCards_d7f9325b from "./en/src--return--return-detail-cards.json";
import model_983a9569 from "./en/src--return--return-details-v2--model.json";
import customer_132ba734 from "./en/src--return--return-details-v2--sections--customer.json";
import header_c23bdcf0 from "./en/src--return--return-details-v2--sections--header.json";
import journey_ef2e49aa from "./en/src--return--return-details-v2--sections--journey.json";
import newItems_a7abf4ca from "./en/src--return--return-details-v2--sections--new-items.json";
import returnItems_c5864e27 from "./en/src--return--return-details-v2--sections--return-items.json";
import returnSummary_bc8c088a from "./en/src--return--return-details-v2--sections--return-summary.json";
import shipping_b83aef00 from "./en/src--return--return-details-v2--sections--shipping.json";
import common_410416d9 from "./en/src--return--return-modals--common.json";
import components_48ecd773 from "./en/src--return--return-modals--create-label--components.json";
import createLabel_6e6d2e19 from "./en/src--return--return-modals--create-label.json";
import newEditModal_ef4dd4ac from "./en/src--return--return-modals--new-edit-modal.json";
import itemEdit_f9d79d91 from "./en/src--return--return-modals--new-process-modal--components--item-edit.json";
import itemRows_48f0e5ab from "./en/src--return--return-modals--new-process-modal--components--item-rows.json";
import modals_f82592ba from "./en/src--return--return-modals--new-process-modal--components--modals.json";
import summary_fce443cc from "./en/src--return--return-modals--new-process-modal--components--summary.json";
import utils_d3882c13 from "./en/src--return--return-modals--new-process-modal--utils.json";
import newProcessModal_557eaec9 from "./en/src--return--return-modals--new-process-modal.json";
import returnAdjustmentModal_1ffd171e from "./en/src--return--return-modals--return-adjustment-modal.json";
import returnModals_1b98aa35 from "./en/src--return--return-modals.json";
import itemPicker_2c460837 from "./en/src--return--return-page-left-panel--item-picker.json";
import productAssessments_15903580 from "./en/src--return--return-page-left-panel--product-assessments.json";
import expandedContent_0b6361b3 from "./en/src--return--return-page-left-panel--return-item--expanded-content.json";
import hooks_cff94563 from "./en/src--return--return-page-left-panel--return-item--hooks.json";
import returnItem_94ad9bbc from "./en/src--return--return-page-left-panel--return-item.json";
import hooks_71fe4421 from "./en/src--return--return-page-left-panel--return-new-item--hooks.json";
import returnNewItem_0938671b from "./en/src--return--return-page-left-panel--return-new-item.json";
import returnPageLeftPanel_0a3a3387 from "./en/src--return--return-page-left-panel.json";
import customerTabs_1959bb46 from "./en/src--return--return-page-right-panel--customer-tabs.json";
import components_e2600652 from "./en/src--return--return-page-right-panel--shipping-details--components.json";
import utils_a6ccdf2c from "./en/src--return--return-page-right-panel--shipping-details--utils.json";
import shippingDetails_5a3101b5 from "./en/src--return--return-page-right-panel--shipping-details.json";
import components_7b4170ac from "./en/src--return--return-page-right-panel--summary-card--components.json";
import summaryCard_edef65ab from "./en/src--return--return-page-right-panel--summary-card.json";
import returnPageRightPanel_80c9f5c6 from "./en/src--return--return-page-right-panel.json";
import tags_5644485d from "./en/src--return--tags.json";
import viewTabs_231f352c from "./en/src--return--view-tabs.json";
import views_622eb8cb from "./en/src--return--views.json";
import walkthrough_b26198d8 from "./en/src--return--walkthrough.json";
import withdrawals_c067dee3 from "./en/src--return--withdrawals.json";
import return_e3a35c3c from "./en/src--return.json";
import global_9445fddc from "./en/src--services--global.json";
import results_47acc994 from "./en/src--setting--ab-tests--results.json";
import abTests_ae8aec1b from "./en/src--setting--ab-tests.json";
import aboutTracking_e1b8586b from "./en/src--setting--about-tracking.json";
import components_12ca386d from "./en/src--setting--ai-agent--components.json";
import aiAgent_e609a76b from "./en/src--setting--ai-agent.json";
import hooks_3a7c82e7 from "./en/src--setting--aptos-settings--hooks.json";
import aptosSettings_cf2de44a from "./en/src--setting--aptos-settings.json";
import assessments_47631f22 from "./en/src--setting--assessments.json";
import attributeDefinitions_21225aab from "./en/src--setting--attribute-definitions.json";
import attribution_86f818b4 from "./en/src--setting--attribution.json";
import flows_75fd65b4 from "./en/src--setting--automation--processing--flows.json";
import processing_194bba37 from "./en/src--setting--automation--processing.json";
import automation_c14b9355 from "./en/src--setting--automation.json";
import orderTracking_6d23cd1e from "./en/src--setting--billing--cards--order-tracking.json";
import returns_b26a1dd0 from "./en/src--setting--billing--cards--returns.json";
import support_c35f7fbc from "./en/src--setting--billing--cards--support.json";
import cards_7d0108e3 from "./en/src--setting--billing--cards.json";
import outboundLabelsLedger_c96f3640 from "./en/src--setting--billing--outbound-labels-ledger.json";
import paymentMethods_ee5cd706 from "./en/src--setting--billing--payment-methods.json";
import videoAnnouncement_96acb2d2 from "./en/src--setting--billing--video-announcement.json";
import billing_78d75a46 from "./en/src--setting--billing.json";
import brightpearlSettings_09110f46 from "./en/src--setting--brightpearl-settings.json";
import bundles_387cb5f5 from "./en/src--setting--bundles.json";
import integrations_61cecd8c from "./en/src--setting--catalog--integrations.json";
import tabs_afd58be1 from "./en/src--setting--channel--voice-and-sms--tabs.json";
import voiceAndSms_d8ac8ae7 from "./en/src--setting--channel--voice-and-sms.json";
import channel_1b3e0023 from "./en/src--setting--channel.json";
import chargebacks_0b2aedde from "./en/src--setting--chargebacks.json";
import commentSoldSettings_4f099b91 from "./en/src--setting--comment-sold-settings.json";
import commerceCloudSettings_73071c93 from "./en/src--setting--commerce-cloud-settings.json";
import data_4fcd2c38 from "./en/src--setting--conversation-tags--data.json";
import conversationTags_84901cad from "./en/src--setting--conversation-tags.json";
import cartOptimization_1681644d from "./en/src--setting--conversion--cart-optimization.json";
import customJs_43ccf7c8 from "./en/src--setting--conversion--custom-js.json";
import deliveryEstimate_b37a2419 from "./en/src--setting--conversion--general--delivery-estimate.json";
import general_2167d670 from "./en/src--setting--conversion--general.json";
import hsa_e6cd7081 from "./en/src--setting--conversion--hsa.json";
import selectorPlacement_31665692 from "./en/src--setting--conversion--selector-placement.json";
import tryFirst_96d86b04 from "./en/src--setting--conversion--try-first.json";
import conversion_b5256399 from "./en/src--setting--conversion.json";
import cordialSettings_1da550d0 from "./en/src--setting--cordial-settings.json";
import ai_3da76898 from "./en/src--setting--coverage--coverage-builder--ai.json";
import coverageBuilder_7d9533ac from "./en/src--setting--coverage--coverage-builder.json";
import coverage_89bc1c73 from "./en/src--setting--coverage.json";
import adBlocks_6a616f16 from "./en/src--setting--customer-accounts--ad-blocks.json";
import integrations_e9a4b31d from "./en/src--setting--customer-accounts--integrations.json";
import customerAccounts_6d01b412 from "./en/src--setting--customer-accounts.json";
import hooks_b6245515 from "./en/src--setting--customer-satisfaction--hooks.json";
import panels_8ecb85f3 from "./en/src--setting--customer-satisfaction--panels.json";
import customerSatisfaction_3598e6f6 from "./en/src--setting--customer-satisfaction.json";
import generalTab_583b12ba from "./en/src--setting--customer-widget--tabs--general-tab.json";
import tabs_69203b95 from "./en/src--setting--customer-widget--tabs.json";
import customerWidget_a15032bc from "./en/src--setting--customer-widget.json";
import hooks_5beb5563 from "./en/src--setting--exchange-agent-guidance--hooks.json";
import modals_73de2b6f from "./en/src--setting--exchange-agent-guidance--modals.json";
import exchangeAgentGuidance_3c2e7c1b from "./en/src--setting--exchange-agent-guidance.json";
import cards_18328676 from "./en/src--setting--exchanges--cards.json";
import components_4db6615d from "./en/src--setting--flow-editor--advanced-flow-editor--components.json";
import common_663e8a7f from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--common.json";
import oms_178ea0e9 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--oms.json";
import rules_42f8ee68 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--rules.json";
import workOrder_55c8943e from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--work-order.json";
import nodes_65031776 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes.json";
import blockCheckout_44c4f4f3 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--block-checkout.json";
import checkoutExperience_908ef3ca from "./en/src--setting--flow-editor--advanced-flow-editor--steps--checkout-experience.json";
import common_9283b062 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--common.json";
import hsa_1a0f953a from "./en/src--setting--flow-editor--advanced-flow-editor--steps--hsa.json";
import inspectors_d251158b from "./en/src--setting--flow-editor--advanced-flow-editor--steps--inspectors.json";
import oms_689131c2 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--oms.json";
import postPurchasePage_c50612e0 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--post-purchase-page.json";
import postPurchaseSegment_966930ae from "./en/src--setting--flow-editor--advanced-flow-editor--steps--post-purchase-segment.json";
import postPurchaseSplit_00578e41 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--post-purchase-split.json";
import addressProperties_5e5bd1c3 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--address-properties.json";
import cartValue_05c1d6fe from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--cart-value.json";
import checkoutProbability_2e6632d0 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--checkout-probability.json";
import compound_477076c3 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--compound.json";
import customerOrderCount_6ab8856d from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--customer-order-count.json";
import customerReturnRate_6173c8d1 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--customer-return-rate.json";
import customerTags_52754824 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--customer-tags.json";
import datetimeRange_9ab53adb from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--datetime-range.json";
import deliveryDistanceMiles_5d0e5711 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--delivery-distance-miles.json";
import deliveryLocation_ab50c22b from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--delivery-location.json";
import historicalOrderValue_f1a0bf53 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--historical-order-value.json";
import itemQuantity_fe65077f from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--item-quantity.json";
import lineItemProperties_a8337f74 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--line-item-properties.json";
import originLocation_17855922 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--origin-location.json";
import productCollections_83fcff6c from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-collections.json";
import productMetafields_b2e09810 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-metafields.json";
import productSku_4f3fe6e2 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-sku.json";
import productTags_444a77e4 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-tags.json";
import productVendor_89a9ef47 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-vendor.json";
import shipmentWeight_ccaa6c42 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--shipment-weight.json";
import timeOfDay_09918241 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--time-of-day.json";
import rcoSegment_d50850e7 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment.json";
import rcoSplit_64abce61 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-split.json";
import rules_eebf4efa from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rules.json";
import supplies_7af6ab22 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--supplies.json";
import trackingPage_f8c8d421 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--tracking-page.json";
import triggerSteps_57faae03 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--trigger-steps.json";
import workOrder_ea1b0b32 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--work-order.json";
import steps_ea74663e from "./en/src--setting--flow-editor--advanced-flow-editor--steps.json";
import utils_dae15842 from "./en/src--setting--flow-editor--advanced-flow-editor--utils.json";
import advancedFlowEditor_1b3baea3 from "./en/src--setting--flow-editor--advanced-flow-editor.json";
import compensationFlow_c41679dc from "./en/src--setting--flow-editor--compensation-flow.json";
import flowAgent_16d913d4 from "./en/src--setting--flow-editor--components--flow-agent.json";
import components_503a04fe from "./en/src--setting--flow-editor--components.json";
import restockingFlow_09365084 from "./en/src--setting--flow-editor--restocking-flow.json";
import utils_e5d0e4b2 from "./en/src--setting--flow-editor--utils.json";
import flowEditor_2ba9e823 from "./en/src--setting--flow-editor.json";
import flows_4e049d65 from "./en/src--setting--flows.json";
import freight_a628e818 from "./en/src--setting--freight.json";
import fulfillmentCutoff_abf14588 from "./en/src--setting--fulfillment-cutoff.json";
import groups_2a17153a from "./en/src--setting--groups.json";
import inmarSettings_f827fc26 from "./en/src--setting--inmar-settings.json";
import catalog_b961c1cd from "./en/src--setting--international--catalog.json";
import components_1604352f from "./en/src--setting--international--components.json";
import hooks_dbed3dbe from "./en/src--setting--international--hooks.json";
import international_283cae55 from "./en/src--setting--international.json";
import inventoryManagement_8e57f75f from "./en/src--setting--inventory-management.json";
import hooks_470fb9dd from "./en/src--setting--klaviyo-settings--hooks.json";
import klaviyoSettings_f5d58fb6 from "./en/src--setting--klaviyo-settings.json";
import labelFlow_6badb251 from "./en/src--setting--label-flow.json";
import components_e92741fe from "./en/src--setting--location-flow--rate-source-selection--components.json";
import rateSourceSelection_eb2a54b3 from "./en/src--setting--location-flow--rate-source-selection.json";
import locationFlow_ea520764 from "./en/src--setting--location-flow.json";
import itemOutcomes_5b4cd137 from "./en/src--setting--managed-returns--item-outcomes.json";
import managedReturns_9276fb89 from "./en/src--setting--managed-returns.json";
import emailDomain_05714be4 from "./en/src--setting--marketing--email-domain.json";
import integrations_4bfb68a1 from "./en/src--setting--marketing--integrations.json";
import subscribeKeywords_cab81338 from "./en/src--setting--marketing--subscribe-keywords.json";
import marketing_1fbfd421 from "./en/src--setting--marketing.json";
import components_c7029ee1 from "./en/src--setting--merchant-recommended-exchanges--components.json";
import narvarSettings_8ad1b5f2 from "./en/src--setting--narvar-settings.json";
import sections_ce7c027e from "./en/src--setting--netsuite-settings--sections.json";
import netsuiteSettings_432f4d28 from "./en/src--setting--netsuite-settings.json";
import automations_302b2894 from "./en/src--setting--oms--automations.json";
import workOrderFlows_740cd927 from "./en/src--setting--oms--work-order-flows.json";
import orderEditing_8bab9fff from "./en/src--setting--order-editing.json";
import orderManagement_9a9bb588 from "./en/src--setting--order-management.json";
import orderTracking_8da85e5d from "./en/src--setting--order-tracking.json";
import pointOfSale_dc118964 from "./en/src--setting--point-of-sale.json";
import product_79f81862 from "./en/src--setting--product.json";
import components_205942a3 from "./en/src--setting--products-as-variants--components.json";
import utils_5e6ed58c from "./en/src--setting--products-as-variants--utils.json";
import productsAsVariants_491f7548 from "./en/src--setting--products-as-variants.json";
import recover_21c04d14 from "./en/src--setting--recover.json";
import shippingRules_dd168639 from "./en/src--setting--redo-supplies--shipping-rules.json";
import conditionTypes_473ee7a9 from "./en/src--setting--return-flow--condition-types.json";
import hooks_0a52aa7f from "./en/src--setting--return-flow--hooks.json";
import translations_11fd3104 from "./en/src--setting--return-flow--translations.json";
import returnFlow_abe765ec from "./en/src--setting--return-flow.json";
import returnProcessingFlows_e7688f00 from "./en/src--setting--return-processing-flows.json";
import creditIncentive_4badce5b from "./en/src--setting--returns--coverage--credit-incentive.json";
import digitalWarehouse_73546773 from "./en/src--setting--returns--coverage--digital-warehouse.json";
import pricing_1a595c2e from "./en/src--setting--returns--coverage--package-protection--pricing.json";
import packageProtection_51fbb10b from "./en/src--setting--returns--coverage--package-protection.json";
import returnCoverage_dfcdaa80 from "./en/src--setting--returns--coverage--return-coverage.json";
import coverage_7b310341 from "./en/src--setting--returns--coverage.json";
import labelBuilder_71732cf3 from "./en/src--setting--returns--labels--label-builder.json";
import labelsFlow_6a3604fa from "./en/src--setting--returns--labels--labels-flow.json";
import packingSlip_6652f475 from "./en/src--setting--returns--labels--packing-slip.json";
import labels_310d5b39 from "./en/src--setting--returns--labels.json";
import returnLocations_1e0cfea1 from "./en/src--setting--returns--locations--return-locations.json";
import locations_f349b5d3 from "./en/src--setting--returns--locations.json";
import bigcommerce_983a7210 from "./en/src--setting--returns--operations--ecommerce--bigcommerce.json";
import shopify_a4456624 from "./en/src--setting--returns--operations--ecommerce--shopify.json";
import inventory_29bab9c0 from "./en/src--setting--returns--operations--inventory.json";
import merchantCreatedReturns_bbe0c625 from "./en/src--setting--returns--operations--merchant-created-returns.json";
import orders_55402396 from "./en/src--setting--returns--operations--orders.json";
import pointOfSale_4658904a from "./en/src--setting--returns--operations--point-of-sale.json";
import processingEvents_91cc8c62 from "./en/src--setting--returns--operations--processing-events.json";
import processing_ed0f45c5 from "./en/src--setting--returns--operations--processing.json";
import returnPageDisplay_518aa962 from "./en/src--setting--returns--operations--return-page-display.json";
import shippingOptions_0759a3e7 from "./en/src--setting--returns--operations--shipping-options.json";
import customRules_8df9cedc from "./en/src--setting--returns--policies--policy-editor--custom-rules.json";
import sections_a0b9d4ef from "./en/src--setting--returns--policies--policy-editor--sections.json";
import steps_b96f8552 from "./en/src--setting--returns--policies--policy-editor--steps.json";
import policyEditor_d0896ec9 from "./en/src--setting--returns--policies--policy-editor.json";
import returnPolicies_938243d3 from "./en/src--setting--returns--policies--return-policies.json";
import policies_202b9558 from "./en/src--setting--returns--policies.json";
import aiExchangeAgent_d5caa4ce from "./en/src--setting--returns--portal--ai-exchange-agent.json";
import bundles_f7a26e5b from "./en/src--setting--returns--portal--bundles.json";
import customerOptions_0f1c768e from "./en/src--setting--returns--portal--customer-options.json";
import exchangeUi_3abc9e69 from "./en/src--setting--returns--portal--exchange-ui.json";
import giftReturns_9d8c4cd5 from "./en/src--setting--returns--portal--gift-returns.json";
import pricing_77885b02 from "./en/src--setting--returns--portal--pricing.json";
import portal_a706f9bd from "./en/src--setting--returns--portal.json";
import emailNotifications_fa6c452d from "./en/src--setting--returns--shopper-notifications--email-notifications.json";
import shopperNotifications_5f16d262 from "./en/src--setting--returns--shopper-notifications.json";
import gradeActions_d95d5be3 from "./en/src--setting--returns--warehouse--grade-actions.json";
import warehouse_28a94a12 from "./en/src--setting--returns--warehouse.json";
import returnsUi_5bdbbfcd from "./en/src--setting--returns-ui.json";
import returns_008a2988 from "./en/src--setting--returns.json";
import riseAiSettings_db29a7c0 from "./en/src--setting--rise-ai-settings.json";
import hooks_41446c53 from "./en/src--setting--ryder-settings--hooks.json";
import ryderSettings_0234ffe0 from "./en/src--setting--ryder-settings.json";
import hooks_3ac81834 from "./en/src--setting--shipbob-settings--hooks.json";
import shipbobSettings_e4c88e2b from "./en/src--setting--shipbob-settings.json";
import components_a66e6c29 from "./en/src--setting--shipping--components.json";
import sections_5fd2f838 from "./en/src--setting--shipping--sections.json";
import shipping_8616a8c1 from "./en/src--setting--shipping.json";
import tagExclusionRules_3757fffe from "./en/src--setting--tag-exclusion-rules.json";
import teamworkCommerceSettings_8af0fc0f from "./en/src--setting--teamwork-commerce-settings.json";
import trackstarSettings_4a1afb7c from "./en/src--setting--trackstar-settings.json";
import hooks_f92117ce from "./en/src--setting--unified-billing--hooks.json";
import overview_b1e1defd from "./en/src--setting--unified-billing--overview.json";
import filters_6407a156 from "./en/src--setting--unified-billing--transactions--components--filters.json";
import components_13226d27 from "./en/src--setting--unified-billing--transactions--components.json";
import transactions_a3e11b0d from "./en/src--setting--unified-billing--transactions.json";
import unifiedBilling_0b2ea22a from "./en/src--setting--unified-billing.json";
import userGroups_eb6df352 from "./en/src--setting--user-groups.json";
import components_59423984 from "./en/src--setting--variant-exchange-guidance--components.json";
import utils_ae9a901d from "./en/src--setting--variant-exchange-guidance--utils.json";
import setting_da37fa54 from "./en/src--setting.json";
import widget_107e847e from "./en/src--setup-guide--components--widget.json";
import utils_bae51d68 from "./en/src--utils.json";
import insights_c5e3ca3a from "./en/support--ai--common--src--insights.json";
import gmail_7408070c from "./en/support--app--src--gmail.json";
import channel_3e5e7e1b from "./en/support--app--src--setting--channel.json";
import chatFlow_ada96ec5 from "./en/support--app--src--setting--chat-flow.json";
import components_8eb90316 from "./en/support--app--src--setting--general--components.json";
import general_2893f61b from "./en/support--app--src--setting--general.json";
import components_d7866404 from "./en/support--app--src--setting--rules--components.json";
import conditions_79cb63ee from "./en/support--app--src--setting--rules--conditions.json";
import actions_3f6340ea from "./en/support--app--src--setting--rules--flow-editor--actions.json";
import conditions_a30632ee from "./en/support--app--src--setting--rules--flow-editor--conditions.json";
import flowEditor_325a07c9 from "./en/support--app--src--setting--rules--flow-editor.json";
import rules_255f87ce from "./en/support--app--src--setting--rules.json";
import setting_4296736e from "./en/support--app--src--setting.json";

export default Object.assign(
  {},
  inboundDashboard_21ed8bad,
  states_a86d9120,
  components_562f17ab,
  filters_b30cdd9f,
  hooks_23683116,
  checkoutPlusRewards_e794283c,
  carriers_055d45e4,
  components_89217572,
  hooks_423890f7,
  insights_1d758917,
  operations_a69114ba,
  components_3852438d,
  overview_f9436386,
  hooks_0198825c,
  components_776871f8,
  portal_21cbb2cf,
  filters_4b179511,
  configs_7d187c89,
  table_e613b3e1,
  components_ccbd5b37,
  product_973280aa,
  components_5c9b22c0,
  hooks_96d4cc66,
  returns_e5c8651f,
  shared_369ac6b7,
  returnsClaims_3629dcf9,
  analytics_75bbeb2b,
  attribution_c773b9ec,
  taxIdentifiers_03bd63a7,
  translations_e8ab17df,
  dns_7ffb1e4d,
  setting_c1bbd3dc,
  support_6d8651c6,
  tag_d63212fd,
  walkthrough_0fcac945,
  actionPanel_35b620eb,
  components_c3b95532,
  cards_5b44e739,
  feedEntry_4c8e9a44,
  customerActivity_15f7b637,
  customerDetail_2cbed25c,
  customEventComponents_855945b8,
  customerJourneyTable_9eb3ba88,
  constants_02c6dc11,
  customerJourney_bf7edacc,
  components_c4508ec9,
  customerRecord_1a5fe625,
  loyalty_5d5d02c8,
  src_3a197aa1,
  logs_67fdff53,
  giftReceiptRequests_963b6dbc,
  inmarBlindReturns_e4bb4f0a,
  brandKit_0b1d74ec,
  communication_04bf5a69,
  ai_1b80877a,
  centerStage_45d156d9,
  header_2eefb12c,
  address_0f0821f3,
  aiExchangeRecommendations_e7d1a7a4,
  cantFindItem_f960bed2,
  compensationMethod_6c0afacd,
  confirmation_9fa1d81f,
  contactInformation_245a8ebf,
  itemDetails_2dc93089,
  login_ac96d533,
  orderDetails_c67a96b6,
  purchaseChannel_3c832b29,
  registrationAddress_b2a4c7f9,
  registrationCatalog_46551a78,
  returnType_28d0b002,
  review_913a5711,
  selectItems_5bac69e1,
  shipmentMethod_a878eb30,
  pages_f2cf29fd,
  translations_ff46a007,
  settings_3063afb8,
  branding_53967c7d,
  globalCards_a039dc7e,
  selectionCards_98c72ba2,
  buttons_101098c3,
  general_7b948df2,
  selection_251813f0,
  typography_1193ed33,
  stylesV2_8a237655,
  styles_7da21905,
  leftPanel_250f52a9,
  rightPanel_754a74ee,
  customerPortalBuilder_27227ac9,
  customerPortal_a30dce25,
  components_d0ef8985,
  modals_4a90e1f7,
  developer_5c5da90e,
  tabs_218e9e8d,
  notification_efc204ed,
  roles_76be9fd7,
  user_32350224,
  withdrawals_46204b05,
  promptHelper_dd9db353,
  shopperAgent_8e5151c4,
  playbook_c693daf2,
  marketingAgent_344332c5,
  settings_7dd2f8d1,
  audienceDashboard_b3f033c0,
  vips_8110ac5c,
  settings_4001f2b5,
  notifications_0d402db5,
  desktopHandoff_b1c27e4d,
  settingsRoutes_c2d5b5e5,
  routing_e6167abf,
  aeo_053900a3,
  analytics_12388d41,
  catalog_90895975,
  conversion_4ba21609,
  customers_6a30f0b6,
  developer_b8383ce2,
  globalSearchTools_2865a997,
  globalSearch_ed826cb9,
  home_d05467c4,
  inventory_432b3f2c,
  marketing_adc89992,
  orders_c583846d,
  payments_2aba0925,
  redoSupplies_d0ce5a55,
  returns_317b6b37,
  shipping_408b74d9,
  shopperAgent_e9556136,
  support_9727fd1a,
  sideNavigation_1d8784bf,
  topNavigation_7821708d,
  app_fbb2aba2,
  components_80f8d596,
  spotCheck_319f9453,
  dashboard_b0e03f73,
  detailPage_24a7606a,
  inspectors_d33c17d5,
  onboardingCards_8c40f8ad,
  onboardingModals_2b3b826a,
  withdrawalsOnboarding_ff91268b,
  homepage_828baad7,
  catalog_ed1c5550,
  configs_59d1feff,
  hooks_afec978a,
  integrationCards_be5acfd5,
  shared_bb073394,
  components_586226e0,
  pages_857590db,
  activationSections_37cde5dc,
  panels_141dca66,
  automations_7008a3c6,
  onboarding_f4ee3d91,
  actionPanel_d7c36aa3,
  hooks_9b9b5238,
  statCards_1fad02c2,
  tnplTimeline_66a262a1,
  orderDetails_dc7b8814,
  ordersTable_c57b9e27,
  orderSyncProgress_58cdab5b,
  orders_0a6b437a,
  order_9b6d226e,
  settings_6f0866a9,
  chargebacks_bf3b0d55,
  hsa_22f2773c,
  walkthrough_03ff12ba,
  plgHomepage_82c55fb1,
  plg_07d99c25,
  inspectors_6caeb6d0,
  popups_0814e281,
  customerTabs_edb94fdc,
  registration_2a4a33c5,
  actionPanel_610b1f2b,
  bar_a1457686,
  modals_a02582b1,
  model_ef9a416c,
  toasts_60c2e7eb,
  bulkActions_c652ed86,
  editItemDisposition_a672bbe4,
  experience_aee5a645,
  fraud_8894238a,
  hooks_e71ccff7,
  processingProgress_c0acce91,
  recordCreate_0506b0ac,
  experience_58941a1d,
  jumpTo_7e9b2c2f,
  needsAction_1e0d46ad,
  quickViews_69372e0d,
  search_2ca595cb,
  sources_b98f900a,
  restockBins_6fa17c68,
  returnActions_ce2f46a2,
  returnDetailCards_d7f9325b,
  model_983a9569,
  customer_132ba734,
  header_c23bdcf0,
  journey_ef2e49aa,
  newItems_a7abf4ca,
  returnItems_c5864e27,
  returnSummary_bc8c088a,
  shipping_b83aef00,
  common_410416d9,
  components_48ecd773,
  createLabel_6e6d2e19,
  newEditModal_ef4dd4ac,
  itemEdit_f9d79d91,
  itemRows_48f0e5ab,
  modals_f82592ba,
  summary_fce443cc,
  utils_d3882c13,
  newProcessModal_557eaec9,
  returnAdjustmentModal_1ffd171e,
  returnModals_1b98aa35,
  itemPicker_2c460837,
  productAssessments_15903580,
  expandedContent_0b6361b3,
  hooks_cff94563,
  returnItem_94ad9bbc,
  hooks_71fe4421,
  returnNewItem_0938671b,
  returnPageLeftPanel_0a3a3387,
  customerTabs_1959bb46,
  components_e2600652,
  utils_a6ccdf2c,
  shippingDetails_5a3101b5,
  components_7b4170ac,
  summaryCard_edef65ab,
  returnPageRightPanel_80c9f5c6,
  tags_5644485d,
  viewTabs_231f352c,
  views_622eb8cb,
  walkthrough_b26198d8,
  withdrawals_c067dee3,
  return_e3a35c3c,
  global_9445fddc,
  results_47acc994,
  abTests_ae8aec1b,
  aboutTracking_e1b8586b,
  components_12ca386d,
  aiAgent_e609a76b,
  hooks_3a7c82e7,
  aptosSettings_cf2de44a,
  assessments_47631f22,
  attributeDefinitions_21225aab,
  attribution_86f818b4,
  flows_75fd65b4,
  processing_194bba37,
  automation_c14b9355,
  orderTracking_6d23cd1e,
  returns_b26a1dd0,
  support_c35f7fbc,
  cards_7d0108e3,
  outboundLabelsLedger_c96f3640,
  paymentMethods_ee5cd706,
  videoAnnouncement_96acb2d2,
  billing_78d75a46,
  brightpearlSettings_09110f46,
  bundles_387cb5f5,
  integrations_61cecd8c,
  tabs_afd58be1,
  voiceAndSms_d8ac8ae7,
  channel_1b3e0023,
  chargebacks_0b2aedde,
  commentSoldSettings_4f099b91,
  commerceCloudSettings_73071c93,
  data_4fcd2c38,
  conversationTags_84901cad,
  cartOptimization_1681644d,
  customJs_43ccf7c8,
  deliveryEstimate_b37a2419,
  general_2167d670,
  hsa_e6cd7081,
  selectorPlacement_31665692,
  tryFirst_96d86b04,
  conversion_b5256399,
  cordialSettings_1da550d0,
  ai_3da76898,
  coverageBuilder_7d9533ac,
  coverage_89bc1c73,
  adBlocks_6a616f16,
  integrations_e9a4b31d,
  customerAccounts_6d01b412,
  hooks_b6245515,
  panels_8ecb85f3,
  customerSatisfaction_3598e6f6,
  generalTab_583b12ba,
  tabs_69203b95,
  customerWidget_a15032bc,
  hooks_5beb5563,
  modals_73de2b6f,
  exchangeAgentGuidance_3c2e7c1b,
  cards_18328676,
  components_4db6615d,
  common_663e8a7f,
  oms_178ea0e9,
  rules_42f8ee68,
  workOrder_55c8943e,
  nodes_65031776,
  blockCheckout_44c4f4f3,
  checkoutExperience_908ef3ca,
  common_9283b062,
  hsa_1a0f953a,
  inspectors_d251158b,
  oms_689131c2,
  postPurchasePage_c50612e0,
  postPurchaseSegment_966930ae,
  postPurchaseSplit_00578e41,
  addressProperties_5e5bd1c3,
  cartValue_05c1d6fe,
  checkoutProbability_2e6632d0,
  compound_477076c3,
  customerOrderCount_6ab8856d,
  customerReturnRate_6173c8d1,
  customerTags_52754824,
  datetimeRange_9ab53adb,
  deliveryDistanceMiles_5d0e5711,
  deliveryLocation_ab50c22b,
  historicalOrderValue_f1a0bf53,
  itemQuantity_fe65077f,
  lineItemProperties_a8337f74,
  originLocation_17855922,
  productCollections_83fcff6c,
  productMetafields_b2e09810,
  productSku_4f3fe6e2,
  productTags_444a77e4,
  productVendor_89a9ef47,
  shipmentWeight_ccaa6c42,
  timeOfDay_09918241,
  rcoSegment_d50850e7,
  rcoSplit_64abce61,
  rules_eebf4efa,
  supplies_7af6ab22,
  trackingPage_f8c8d421,
  triggerSteps_57faae03,
  workOrder_ea1b0b32,
  steps_ea74663e,
  utils_dae15842,
  advancedFlowEditor_1b3baea3,
  compensationFlow_c41679dc,
  flowAgent_16d913d4,
  components_503a04fe,
  restockingFlow_09365084,
  utils_e5d0e4b2,
  flowEditor_2ba9e823,
  flows_4e049d65,
  freight_a628e818,
  fulfillmentCutoff_abf14588,
  groups_2a17153a,
  inmarSettings_f827fc26,
  catalog_b961c1cd,
  components_1604352f,
  hooks_dbed3dbe,
  international_283cae55,
  inventoryManagement_8e57f75f,
  hooks_470fb9dd,
  klaviyoSettings_f5d58fb6,
  labelFlow_6badb251,
  components_e92741fe,
  rateSourceSelection_eb2a54b3,
  locationFlow_ea520764,
  itemOutcomes_5b4cd137,
  managedReturns_9276fb89,
  emailDomain_05714be4,
  integrations_4bfb68a1,
  subscribeKeywords_cab81338,
  marketing_1fbfd421,
  components_c7029ee1,
  narvarSettings_8ad1b5f2,
  sections_ce7c027e,
  netsuiteSettings_432f4d28,
  automations_302b2894,
  workOrderFlows_740cd927,
  orderEditing_8bab9fff,
  orderManagement_9a9bb588,
  orderTracking_8da85e5d,
  pointOfSale_dc118964,
  product_79f81862,
  components_205942a3,
  utils_5e6ed58c,
  productsAsVariants_491f7548,
  recover_21c04d14,
  shippingRules_dd168639,
  conditionTypes_473ee7a9,
  hooks_0a52aa7f,
  translations_11fd3104,
  returnFlow_abe765ec,
  returnProcessingFlows_e7688f00,
  creditIncentive_4badce5b,
  digitalWarehouse_73546773,
  pricing_1a595c2e,
  packageProtection_51fbb10b,
  returnCoverage_dfcdaa80,
  coverage_7b310341,
  labelBuilder_71732cf3,
  labelsFlow_6a3604fa,
  packingSlip_6652f475,
  labels_310d5b39,
  returnLocations_1e0cfea1,
  locations_f349b5d3,
  bigcommerce_983a7210,
  shopify_a4456624,
  inventory_29bab9c0,
  merchantCreatedReturns_bbe0c625,
  orders_55402396,
  pointOfSale_4658904a,
  processingEvents_91cc8c62,
  processing_ed0f45c5,
  returnPageDisplay_518aa962,
  shippingOptions_0759a3e7,
  customRules_8df9cedc,
  sections_a0b9d4ef,
  steps_b96f8552,
  policyEditor_d0896ec9,
  returnPolicies_938243d3,
  policies_202b9558,
  aiExchangeAgent_d5caa4ce,
  bundles_f7a26e5b,
  customerOptions_0f1c768e,
  exchangeUi_3abc9e69,
  giftReturns_9d8c4cd5,
  pricing_77885b02,
  portal_a706f9bd,
  emailNotifications_fa6c452d,
  shopperNotifications_5f16d262,
  gradeActions_d95d5be3,
  warehouse_28a94a12,
  returnsUi_5bdbbfcd,
  returns_008a2988,
  riseAiSettings_db29a7c0,
  hooks_41446c53,
  ryderSettings_0234ffe0,
  hooks_3ac81834,
  shipbobSettings_e4c88e2b,
  components_a66e6c29,
  sections_5fd2f838,
  shipping_8616a8c1,
  tagExclusionRules_3757fffe,
  teamworkCommerceSettings_8af0fc0f,
  trackstarSettings_4a1afb7c,
  hooks_f92117ce,
  overview_b1e1defd,
  filters_6407a156,
  components_13226d27,
  transactions_a3e11b0d,
  unifiedBilling_0b2ea22a,
  userGroups_eb6df352,
  components_59423984,
  utils_ae9a901d,
  setting_da37fa54,
  widget_107e847e,
  utils_bae51d68,
  insights_c5e3ca3a,
  gmail_7408070c,
  channel_3e5e7e1b,
  chatFlow_ada96ec5,
  components_8eb90316,
  general_2893f61b,
  components_d7866404,
  conditions_79cb63ee,
  actions_3f6340ea,
  conditions_a30632ee,
  flowEditor_325a07c9,
  rules_255f87ce,
  setting_4296736e,
);
